module.exports = __webpack_public_path__ + "static/media/VIP_Hour_Tile_FREE@3x.4dd3af48.png";